<div class="page">
  <h1>{{ title }}</h1>

  <div class="toolbar card">
    <label>Model:</label>
    <select [ngModel]="selectedModelPath" (ngModelChange)="onChangeModel($event)">
      <option *ngFor="let m of models" [value]="m.path">{{ m.label }}</option>
    </select>
    <small>Farklı SUT kuralları için model seç.</small>
  </div>

  <ol class="stepper">
    <li *ngFor="let s of visibleSteps; let i = index"
        [class.active]="i === currentStepIndex"
        (click)="go(i)">
      <span class="idx">{{ i + 1 }}</span><span class="ttl">{{ s.title }}</span>
    </li>
  </ol>

  <!-- STEP 1 -->
  <section class="card" *ngIf="visibleSteps[currentStepIndex]?.id === 'step1'">
    <h2>{{ visibleSteps[currentStepIndex].title }}</h2>
    <div class="grid">
      <div>
        <label>Hizmet Türü</label>
        <select [formControl]="s1.get('setting')">
          <option value="outpatient">Ayakta</option>
          <option value="inpatient">Yatan</option>
        </select>
        <small *ngIf="flags.inpatientOnly">Bu modelde yalnızca "Yatan" geçerlidir.</small>
      </div>

      <div>
        <label>Günlük doz yazılı mı?</label>
        <input type="checkbox" [formControl]="s1.get('daily_dose_present')" />
      </div>
    </div>
    <div class="nav"><button (click)="next()" [disabled]="!visibleSteps[currentStepIndex].valid()">İleri</button></div>
  </section>

  <!-- STEP 2 -->
  <section class="card" *ngIf="visibleSteps[currentStepIndex]?.id === 'step2'">
    <h2>{{ visibleSteps[currentStepIndex].title }}</h2>
    <div class="grid">
      <div>
        <label>İlk reçete mi?</label>
        <input type="checkbox" [formControl]="s2.get('is_first_prescription')" />
      </div>
      <div>
        <label>Temin gün sayısı</label>
        <input type="number" min="1" [formControl]="s2.get('supply_days')" />
        <small *ngIf="flags.usesSupplyAny">
          Maks: {{ s2.get('is_first_prescription')?.value ? 31 : (s2.get('report_present')?.value ? 93 : 31) }} gün.
        </small>
      </div>

      <div class="full"><hr></div>

      <div class="full">
        <label>Rapor var mı?</label>
        <input type="checkbox" [formControl]="s2.get('report_present')" />
      </div>

      <ng-container *ngIf="s2.get('report_present')?.value === true">
        <div>
          <label>Rapor uzmanlık</label>
          <input type="text" placeholder="Uzman hekim" [formControl]="s2.get('issuer_specialty')" />
        </div>
        <div>
          <label>Rapor kurum</label>
          <input type="text" placeholder="any" [formControl]="s2.get('issuer_institution')" />
        </div>
        <div>
          <label>Rapor geçerlilik (yıl)</label>
          <input type="number" min="0" [formControl]="s2.get('validity_years')" />
          <small>Max 2 yıl.</small>
        </div>
        <div *ngIf="flags.hasCopayCheck">
          <label>ICD-10</label>
          <input type="text" placeholder="I10, C50, D50..." [formControl]="s2.get('icd')" />
        </div>
      </ng-container>
    </div>

    <div class="nav">
      <button class="ghost" (click)="prev()">Geri</button>
      <button (click)="next()" [disabled]="!visibleSteps[currentStepIndex].valid()">İleri</button>
    </div>
  </section>

  <!-- STEP 3 -->
  <section class="card" *ngIf="visibleSteps[currentStepIndex]?.id === 'step3'">
    <h2>{{ visibleSteps[currentStepIndex].title }}</h2>
    <div class="grid">
      <div>
        <label>Hastane kullanımı</label>
        <input type="checkbox" [formControl]="s3.get('hospital_use')" />
      </div>

      <div *ngIf="flags.needsDayCare">
        <label>Günübirlik tedavi</label>
        <input type="checkbox" [formControl]="s3.get('is_day_care')" />
      </div>

      <div>
        <label>Endikasyon</label>
        <input type="text" placeholder="hafif_orta_agri / ileri_agri_opioid / ates ..." [formControl]="s3.get('indication')" />
      </div>

      <div *ngIf="flags.needsDoseCap">
        <label>Günlük doz (max {{ maxDailyDose }})</label>
        <input type="number" [formControl]="s3.get('daily_dose')" />
      </div>
    </div>

    <div class="nav">
      <button class="ghost" (click)="prev()">Geri</button>
      <button (click)="next()" [disabled]="!visibleSteps[currentStepIndex].valid()">Sonuca Git</button>
    </div>
  </section>

  <!-- STEP 4 -->
  <section class="card" *ngIf="visibleSteps[currentStepIndex]?.id === 'step4'">
    <h2>{{ visibleSteps[currentStepIndex].title }}</h2>
    <div class="grid">
      <div><label>Renkli reçete</label><input type="checkbox" [formControl]="s4.get('colored_rx')" /></div>
      <div><label>Endikasyon dışı onay</label><input type="checkbox" [formControl]="s4.get('off_label_approval')" /></div>
      <div><label>Yurt dışı temin</label><input type="checkbox" [formControl]="s4.get('imported_drug')" /></div>
      <div>
        <label>SUT istisna maddesi</label>
        <input type="text" placeholder="4.2.10" [formControl]="s4.get('sut_exclusion_article')" />
      </div>
      <div><label>SGK ayrıca hariç</label><input type="checkbox" [formControl]="s4.get('sgk_specific_excluded')" /></div>
    </div>

    <div class="nav">
      <button class="ghost" (click)="prev()">Geri</button>
      <button (click)="next()">Sonuca Git</button>
    </div>
  </section>

  <!-- RESULT -->
  <section class="card" *ngIf="visibleSteps[currentStepIndex]?.id === 'result'">
    <h2>{{ visibleSteps[currentStepIndex].title }}</h2>

    <ng-container *ngIf="result as r; else nores">
      <p><strong>Durum:</strong> {{ r.status }}</p>
      <p *ngIf="r.copay"><strong>Katılım Payı:</strong> {{ r.copay }}</p>
    </ng-container>
    <ng-template #nores><p>Henüz değerlendirilmedi.</p></ng-template>

    <details>
      <summary>İz (Trace) detayını göster</summary>
      <table class="trace">
        <thead><tr><th>Tür</th><th>Düğüm</th><th>OK?</th><th>Detay</th></tr></thead>
        <tbody>
          <tr *ngFor="let t of trace">
            <td>{{ t.type }}</td>
            <td>{{ t.nodeId || '-' }}</td>
            <td *ngIf="t.ok !== undefined">{{ t.ok }}</td>
            <td *ngIf="t.ok === undefined">-</td>
            <td>{{ t.detail || '' }}</td>
          </tr>
        </tbody>
      </table>
    </details>

    <div class="nav">
      <button class="ghost" (click)="prev()">Geri</button>
      <button (click)="go(0)">Başa Dön</button>
    </div>
  </section>
</div>
